import {useLocation, useNavigate} from "react-router-dom";
import {createContext, useContext} from "react";

const NavigationContext = createContext();

export const NavigationProvider = ({children}) => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleNavigation = (path) => {
        const [_, lang] = location.pathname.split('/');
        sessionStorage.removeItem("scrollPosition");
        sessionStorage.removeItem("previousPage");

        navigate(lang + path);
    };

    const navigateFromBackButton = (path) => {
        const [_, lang] = location.pathname.split('/');
        sessionStorage.setItem("previousPage", window.location.pathname);
        sessionStorage.setItem("scrollPosition", window.scrollY);

        navigate(lang + path);
    };

    return (
        <NavigationContext.Provider value={{handleNavigation, navigateFromBackButton}}>
            {children}
        </NavigationContext.Provider>
    );
}

export const useNavigation = () => {
    return useContext(NavigationContext);
};
